import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class LoadingPortal extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    };

    constructor() {
        super();
        this.el = document.createElement('div');
        this.loadingPortalRoot = document.getElementById('loading-portal');
    }

    componentDidMount() {
        if (this.loadingPortalRoot) {
            this.loadingPortalRoot.appendChild(this.el);
            setTimeout(() => {
                this.el.classList.add('loading-portal-visible');
            }, 0);
        }
    }

    componentWillUnmount() {
        if (this.loadingPortalRoot) {
            this.loadingPortalRoot.removeChild(this.el);
        }
    }

    render() {
        const { children, className = 'loading-portal' } = this.props;
        this.el.className = className;
        return ReactDOM.createPortal(children, this.el);
    }
}
